<div style="margin-bottom: 50px;">
    <aw-wizard id="mb-wizard" #wizard [disableNavigationBar]='true' [navBarLocation]="'top'" [awNavigationMode]
        navigateBackward="deny">
        <aw-wizard-step stepId="0" *ngIf="isShowPreference" stepTitle="Merchant Invoicing Preferences">
            <ng-container *ngIf="!prefLoader">
                <div class="card list-view card-list-bg mb-5">
                    <div class="card-header list-header px-0 py-2 list">
                        <div class="col-md-12 row pr-0 m-0">
                            <p class="card-text mt-1 text-left">
                                <span class="font-weight-bold">
                                    <h5> {{'mb.collInfo' | translate}}</h5>
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="card-body carding p-5">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex flex-column">
                                <div class="font-weight-bold mb-1">
                                    <h5>{{'mb.mDba' | translate}}</h5>
                                </div>
                                <div ngbDropdown container="body">
                                    <p class="over-flow" ngbDropdownToggle data-toggle="tooltip" data-placement="bottom"
                                        title="Merchant DBA">
                                        <u class="hover-text"
                                            style="color: rgb(94, 108, 132);cursor: pointer">{{merchantInfo.dba}}
                                        </u>
                                    </p>
                                    <div>
                                        <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                                            <a ngbDropdownItem class="d-flex align-items-center"
                                                (click)="navigateFn('EDIT_MERCHANT')">
                                                <span class="feather icon-edit mr-1">
                                                </span>
                                                <span>{{'Edit Merchant'}}
                                                </span>
                                            </a>
                                            <a ngbDropdownItem class="d-flex align-items-center" (click)="loginAs()"
                                                [disabled]="isDisableProxyLogin">
                                                <span class="feather icon-user mr-1">
                                                </span>
                                                <span>{{'Login to Collection Account'}}
                                                </span>
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="font-weight-bold mb-1">
                                    <h5>{{'mb.sDba' | translate}}</h5>
                                </div>
                                <div ngbDropdown container="body">
                                    <p class="over-flow" ngbDropdownToggle data-toggle="tooltip" data-placement="bottom"
                                        title="Store DBA">
                                        <u class="hover-text"
                                            style="color: rgb(94, 108, 132);cursor: pointer">{{storeInfo.dba}}
                                        </u>
                                    </p>
                                    <div>
                                        <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                                            <a ngbDropdownItem class="d-flex align-items-center"
                                                (click)="navigateFn('EDIT_STORE')">
                                                <span class="feather icon-edit mr-1">
                                                </span>
                                                <span>{{'Edit Store'}}
                                                </span>
                                            </a>
                                            <a ngbDropdownItem class="d-flex align-items-center"
                                                (click)="navigateFn('ADD_ON_FEATURE')">
                                                <span class="feather icon-plus-circle mr-1">
                                                </span>

                                                <span>{{'Add-on Features'}}
                                                </span>
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="font-weight-bold mb-1">
                                    <h5>{{'mb.tpn' | translate}}</h5>
                                </div>
                                <div ngbDropdown container="body">
                                    <p class="over-flow" ngbDropdownToggle data-toggle="tooltip" data-placement="bottom"
                                        title="TPN">
                                        <u class="hover-text"
                                            style="color: rgb(94, 108, 132);cursor: pointer">{{tpnInfo.tpn}}{{tpnInfo.defaultLabel
                                            ?
                                            '('+tpnInfo.defaultLabel+')':''}}
                                        </u>
                                    </p>
                                    <div>
                                        <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                                            <a ngbDropdownItem class="d-flex align-items-center"
                                                (click)="navigateFn('ABOUT_DEVICE')">
                                                <span class="feather icon-smartphone mr-1">
                                                </span>
                                                <span>{{'About Device'}}
                                                </span>
                                            </a>
                                            <a ngbDropdownItem class="d-flex align-items-center"
                                                (click)="navigateFn('EDIT_PARAMS')">
                                                <span class="feather icon-edit mr-1">
                                                </span>
                                                <span>{{'Edit Parameter'}}
                                                </span>
                                            </a>
                                            <a ngbDropdownItem class="d-flex align-items-center"
                                                (click)="navigateFn('EDIT_TPN')">
                                                <span class="feather icon-edit mr-1">
                                                </span>

                                                <span>{{'Edit Processor Info'}}
                                                </span>
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="card list-view card-list-bg">
                    <div class="card-header list-header px-0 py-2 list">
                        <div class="col-md-12 row pr-0 m-0">
                            <p class="card-text mt-1 text-left">
                                <span class="font-weight-bold">
                                    <h5> {{'mb.custInAndPay' | translate}}</h5>
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="card-body carding p-5">
                        <form [formGroup]="billingPreferenceForm">


                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <p-fieldset id="p-fieldset-css">
                                        <ng-template pTemplate="header">
                                            {{ 'mb.sendLinkDesc' | translate }}
                                            <i class="mdi mdi-help-circle"
                                                pTooltip="{{ 'mb.sendLinkDescContent' | translate }}"
                                                tooltipPosition="right"></i>
                                        </ng-template>

                                        <textarea formControlName="paymentLinkDescription"
                                            placeholder="Enter payment link description" pInputTextarea rows="5"
                                            [maxlength]="150" class="form-control"></textarea>
                                    </p-fieldset>
                                </div>

                                <div class="col-md-6">
                                    <p-fieldset id="p-fieldset-css">
                                        <ng-template pTemplate="header">
                                            {{ 'mb.sendLinkDisc' | translate }}
                                            <i class="mdi mdi-help-circle"
                                                pTooltip="{{ 'mb.sendLinkDiscContent' | translate }}"
                                                tooltipPosition="right"></i>
                                        </ng-template>

                                        <textarea formControlName="disclaimer"
                                            placeholder="Enter payment link disclaimer" pInputTextarea rows="5"
                                            [maxlength]="150" class="form-control"></textarea>

                                    </p-fieldset>
                                </div>
                            </div>
                            <div class="text-danger"
                                *ngIf="billingPreferenceForm.get('paymentLinkDescription')?.invalid || billingPreferenceForm.get('disclaimer')?.invalid">
                                <div
                                    *ngIf="!!billingPreferenceForm.get('paymentLinkDescription')?.errors?.['pattern'] || !!billingPreferenceForm.get('disclaimer')?.errors?.['pattern']">
                                    Invalid characters. Only letters, numbers, spaces, and _$'.!%,-@& are allowed.
                                </div>
                            </div>

                            <div>
                                <p-messages severity="warn" id="p-message-css">
                                    <ng-template style="display: block;" pTemplate>
                                        <p class="font-weight-bold">NOTE:</p>
                                        <p>Please log in to your Collection account and upload your logo. This logo will
                                            appear on your invoices and payment links.
                                        </p>
                                        <p>To upload: Collection account → Settings → Upload Logo</p>
                                    </ng-template>
                                </p-messages>

                            </div>
                        </form>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="prefLoader">
                <app-loading> </app-loading>
            </ng-container>

            <div class="d-flex justify-content-end align-items-center fixed-bar" style="padding: 10px 0px 30px 0px">
                <button *ngIf="!prefLoader" type="button" [disabled]="billingPreferenceForm?.invalid" (click)="goToStep(1)" class="btn btn-primary btn-sm mt-3"
                    style="margin-right: 60px;">
                    {{'Next' | translate}}
                </button>
            </div>

        </aw-wizard-step>
        <aw-wizard-step stepId="1" stepTitle="Set Selling Price">

            <app-merchant-contract (contractForm)="contractFormFn($event)" 
                (contractLoaderFn)="contractFormLoaderFn($event)" [disable]="!editBilling"></app-merchant-contract>

            <div class="d-flex fixed-bar align-items-center" *ngIf="conractFormLoader == 'false'">

                <ng-container *ngIf="isAccess(modules.MERCHANT_BILLING, privileges.EDIT_BILLING)">
                    <p-messages [ngStyle]="{ visibility: queryParams.setSellingPrice ? 'hidden' : 'visible' }"
                        severity="warn" id="p-message-css-1" class="mb-0" style="margin-left: 60px;">
                        <ng-template pTemplate>
                            <p class="mb-0">
                                The default rate has been pre-filled for your convenience. You can adjust the rate and
                                set it as
                                your default price.
                            </p>
                        </ng-template>
                    </p-messages>
                </ng-container>

                <div class="d-flex align-items-center ml-auto">

                    <ng-container *ngIf="!isAccess(modules.MERCHANT_BILLING, privileges.EDIT_BILLING)">
                        <p-messages severity="error" id="p-message-css-1" class="mb-0 mr-3 align-self-center">
                            <ng-template pTemplate>
                                <p class="mb-0 px-1 d-flex align-items-center">
                                    <strong>View Only</strong>
                                    <span class="ml-2">
                                        <i data-feather="help-circle" appFeatherIcon class="icon-sm"></i>
                                    </span>
                                </p>
                            </ng-template>
                        </p-messages>
                    </ng-container>

                    <div class="d-flex align-items-center" style="margin-right: 60px;">
                        <button type="submit" [disabled]="submitLoader" (click)="goToStep()"
                            class="btn btn-outline-primary btn-sm mr-2">
                            {{ 'Back' | translate }}
                        </button>

                        <button type="submit" class="btn btn-primary btn-sm" (click)="submitForm()"
                            [disabled]="
                                                              !isAccess(modules.MERCHANT_BILLING, privileges.EDIT_BILLING) ||
                                                              submitLoader ||
                                                              conractForm?.invalid ||
                                                              (from == 'bulk_update' ? !conractForm?.isChanged : false)">
                            {{ (from == 'bulk_update' ? 'mb.bulkUpdate' : from == 'bulk_enable' ? 'mb.bulkEnable'
                            : 'Save') | translate }}
                            <span *ngIf="submitLoader" class="spinner-border spinner-border-sm ml-1" role="status"
                                aria-hidden="true">
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </aw-wizard-step>
    </aw-wizard>
</div>